import { z } from 'zod';
import { AppliedProjectTag } from './get-project';
export const PreviewProjectSummary = z.object({
    slug: z.string(),
    name: z.string(),
    description: z.string(),
    image_url: z.string().nullable(),
    topic: z.string(),
    question_count: z.number(),
    tags: z.array(AppliedProjectTag),
    is_joined: z.boolean(),
    is_finished: z.boolean(),
    is_submitted: z.boolean(),
    answer_states: z.null(),
});
export const GetPreviewProjectsResponse = z.array(PreviewProjectSummary);
export const getPreviewProjectsRoute = {
    version: 1,
    method: 'GET',
    path: '/preview/projects/',
    name: 'get-preview-projects',
    request: {},
    responses: { 200: GetPreviewProjectsResponse },
};
